<style src="./Simple.scss" lang="scss"></style>

<script>
	import Icon from '@/components/Icon/Icon';
	import Image from '@/components/Image/Image';

	/**
	 * Simple component consisting of image and text.
	 * @vue-prop {Object} [link] the link object
	 * @vue-prop {Object} [figure] the figure object
	 * @vue-prop {Object} [icon] the icon object
	 * @vue-prop {String} [text] the text of the simple
	 * @vue-prop {('vertical' | 'horizontal' | 'vertical-reverse' | 'horizontal-reverse')} [orientation] The direction of the component
	 * @vue-prop {('rectangle' | 'circle')} shape The shape of the image
	 * @vue-prop {('' | 'grey')} [backgroundColor] Color of the background of whole component
	 * @fires Simple#click
	 */
	export default {
		props: {
			link: Object,
			figure: Object,
			icon: Object,
			text: String,
			orientation: {
				type: String,
				default: 'vertical',
				validator: function (value) {
					return ['vertical', 'horizontal', 'vertical-reverse', 'horizontal-reverse'].indexOf(value) !== -1;
				}
			},
			shape: {
				type: String,
				validator: function (value) {
					return ['rectangle', 'circle'].indexOf(value) !== -1;
				}
			},
			backgroundColor: String
		},
		components: {
			'hp-icon': Icon,
			'hp-image': Image
		}
	};
</script>

<template>
	<component :is="link ? 'a' : 'div'" :href="link && link.href ? link.href : false" :target="link && link.target ? link.target : false" @click="$emit('click')">
		<figure data-component="simple" :data-orientation="orientation" :data-background-color="backgroundColor">
			<div v-if="icon" :data-background-color="icon.bgColor">
				<hp-icon :type="icon.type"></hp-icon>
			</div>
      <hp-image v-else v-bind="figure.img" :data-shape="shape"></hp-image>
			<figcaption>{{ text }}</figcaption>
		</figure>
	</component>
</template>
